import React from "react";
import { NavLink } from "react-router-dom";

const PageBanner = ({ title }) => (
  <section className="page_title ds s-overlay s-parallax s-py-5">
    <div className="container">
      <div className="row">
        <div className="col-md-12 text-center">
          <h1 className="bold">{title} </h1>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <NavLink to="/">
                <a href="index.html">Home</a>
              </NavLink>
            </li>
            <li className="breadcrumb-item active">{title}</li>
          </ol>
        </div>
      </div>
    </div>
  </section>
);

export default PageBanner;
